// eslint-disable-next-line import/no-anonymous-default-export
export default {
  l10n: {
    date: {
      months: {
        full: [
          'enero',
          'febrero',
          'marzo',
          'abril',
          'mayo',
          'junio',
          'julio',
          'agosto',
          'septiembre',
          'octubre',
          'noviembre',
          'diciembre',
        ],
        abbr: [
          'ene.',
          'feb.',
          'mar.',
          'abr.',
          'may.',
          'jun.',
          'jul.',
          'ago.',
          'sep.',
          'oct.',
          'nov.',
          'dic.',
        ],
      },
      days: {
        full: [
          'domingo',
          'lunes',
          'martes',
          'miércoles',
          'jueves',
          'viernes',
          'sábado',
        ],
        abbr: ['do.', 'lu.', 'ma.', 'mi.', 'ju.', 'vi.', 'sá.'],
      },
      patterns: {
        longDate: 'dddd, D MMMM YYYY',
        dateSlash: 'DD/MM/YYYY',
        dateShort: 'dddd D MMMM',
        dateShortWithDay: 'Do MMMM YYYY',
        dateMedium: 'dddd D MMMM - H[.]mm',
        dateMediumReversed: 'H[.]mm - D MMMM YYYY',
        dateMediumSlash: 'DD[/]MM[/]YYYY [alle] H[.]mm',
        dateLarge: 'D/MMM/YYYY [alle] HH[.]mm',
        timeShort: 'LT',
        timeMedium: 'DD[/]MM LT',
      },
    },
    number: {
      patterns: {
        standard: ['-n', 'n'],
        amount: ['-nS', 'nS'],
      },
      group: {
        separator: '.',
        length: 3,
        abbr: ['', 'k', 'M', 'B'],
      },
      decimal: {
        separator: ',',
        length: 2,
      },
      ordinal: function (number) {
        return number + (number === 1 ? '°' : '°');
      },
    },
  },
  translations: {
    messages: {
      Cart: [null, 'Carrello'],
      Favourites: [null, 'Preferiti'],
      Delivery: [null, 'Spedizione'],
      Summary: [null, 'Riepilogo'],
      Order: [null, 'Ordine'],
      Categories: [null, 'Categorie'],
      'No results found': [null, 'Nessun risultato'],
      'No favourites': [null, 'Nessun preferito'],
      'Empty cart': [null, 'Carrello vuoto'],
      'No order': [null, 'Nessun ordine'],
      'Add to cart': [null, 'Aggiungi al carrello'],
      Included: [null, 'Inclusa'],
      Delete: [null, 'Elimina'],
      Items: [null, 'Articoli'],
      Description: [null, 'Descrizione'],
      Quantity: [null, 'Quantità'],
      Price: [null, 'Prezzo'],
      'Where would you like to receive your order?': [
        null,
        'A quale indirizzo desideri ricevere il tuo ordine?',
      ],
      Address: [null, 'Indirizzo'],
      'Address details': [null, 'Indirizzo aggiuntivo'],
      'Estimated delivery date': [null, 'Data di consegna prevista'],
      'Confirm delivery': [null, 'Conferma spedizione'],
      Form: [null, 'Modulo'],
      'Winamax account address': [null, 'Indirizzo del tuo conto Winamax'],
      'Other address': [null, 'Altro indirizzo'],
      'Please select an address in Europe': [
        null,
        'Si prega di selezionare un indirizzo in Europa',
      ],
      'Search an address': [null, 'Trova un indirizzo'],
      'Please complete required fields': [
        null,
        'Si prega di completare i campi richiesti',
      ],
      'Enter your personal information': [null, 'Inserisci i tuoi dati'],
      'Address 2': [null, 'Indirizzo 2'],
      Postcode: [null, 'CAP'],
      City: [null, 'Città'],
      'Telephone number': [null, 'Numero di telefono'],
      'I agree for my account to be debited': [
        null,
        'Accetto che il mio conto sia addebitato',
      ],
      Confirmation: [null, 'Conferma'],
      Save: [null, 'Salva'],
      'View order': [null, 'Vedi ordine'],
      'Back to the shop': [null, 'Torna allo shop'],
      Orders: [null, 'Ordini'],
      Pay: [null, 'Paga'],
      'Thank you': [null, 'Grazie'],
      'We have received your order': [null, 'Abbiamo ricevuto il tuo ordine'],
      'You will receive a confirmation e-mail shortly': [
        null,
        "Riceverai un'email di conferma tra poco.",
      ],
      'In progress': [null, 'In corso'],
      Completed: [null, 'Terminati'],
      'Order status': [null, "Stato dell'ordine"],
      'Contact support': [null, 'Contatta il supporto'],
      'Track order': [null, 'Segui la spedizione'],
      'Order date': [null, 'Data di ordine'],
      'Order number': [null, 'Numero di ordine'],
      Sort: [null, 'Filtra'],
      Miles: [null, 'Miglia'],
      'View results': [null, 'Vedi risultati'],
      Recommended: [null, 'Suggeriti'],
      'Price ascending': [null, 'Prezzo crescente'],
      'Price descending': [null, 'Prezzo decrescente'],
      'Show only products I can buy': [
        null,
        'Mostra unicamente gli articoli che posso acquistare',
      ],
      Under: [null, 'Meno di'],
      Over: [null, 'Più di'],
      Validate: [null, 'Conferma'],
      Cancel: [null, 'Annulla'],
      'Confirm cancellation': [null, 'Conferma annullazione'],
      'Are you sure you want to delete this item?': [
        null,
        'Sei sicuro di voler eliminare questo elemento?',
      ],
      'Product added to favorites': [null, 'Articolo aggiunto ai preferiti'],
      'Product added to cart': [null, 'Articolo aggiunto al carrello'],
      See: [null, 'Vedi'],
      'PRICE CHANGE': [null, 'CAMBIAMENTO DI PREZZO'],
      'The price of the %1$s product has changed. It will be adjusted in your cart.':
        [
          null,
          "Il prezzo dell'articolo %1$s è cambiato. La modifica sarà visibile nel tuo carrello.",
        ],
      'QUANTITY UNAVAILABLE': [null, 'QUANTITÀ INDISPONIBILE'],
      'We are sorry, the %1$s product is no longer available in the quantity you selected.':
        [
          null,
          "Siamo spiacenti, l'articolo %1$s non è più disponibile nella quantità da te indicata.",
        ],
      'Product unavailable': [null, 'Articolo indisponibile'],
      'We are sorry, the %1$s product is no longer available. It will be removed from your cart.':
        [
          null,
          "Siamo spiacenti, l'articolo %1$s non è più disponibile e sarà eliminato dal tuo carrello.",
        ],
      Phone: [null, 'Telefono'],
      All: [null, 'Tutto'],
      Maintenance: [null, 'Manutenzione'],
      Fitting: [null, 'Fitting'], // This is not translated, as "Fitting" might have different meanings. You might want to provide a context or use an Italian equivalent based on the context.
      Manufacturer: [null, 'Fabbricazione'],
      Back: [null, 'Ritorno'],

      // ORDER STATUS
      'Order ready for delivery': [null, 'Ordine pronto per la spedizione'],
      'Order being prepared': [null, 'Ordine in preparazione'],
      'Order in process': [null, 'Ordine in corso di trattamento'],
      'Order being delivered': [null, 'Ordine in corso di spedizione'],
      'This order requires some action on your part': [
        null,
        'L’ordine necessita il tuo intervento',
      ],
      'Order being processed manually': [
        null,
        'Ordine in corso di trattamento manuale',
      ],
      'Order completed': [null, 'Ordine completato'],
      'Order returned': [null, 'Ordine restituito'],
      'Order cancelled': [null, 'Ordine cancellato'],
      'Order resubmitted': [null, 'Ordine riavviato'],
      'Order refunded': [null, 'Ordine rimborsato'],

      // CART ERRORS
      IMPORTANT: [null, 'ATTENZIONE'],
      'Some products could not be ordered due to %1$s. \n You can find them in your cart.':
        [
          null,
          "Non è stato possibile effettuare l'ordine di alcuni articoli: %1$s. \n Puoi ritrovare gli articoli in questione nel tuo carrello.",
        ],
      CONFIRM: [null, 'CONFERMA'],
      'Unable to order': [null, 'Ordine non possibile'],
      'Your order could not be completed because of %1$s': [
        null,
        "Impossibile completare l'ordine a causa di %1$s.",
      ],
      'Your order could not be completed': [
        null,
        'Non è stato possibile completare il tuo ordine',
      ],
      'Back to cart': [null, 'Torna al carrello'],

      // DEBIT MILES ERRORS
      'an identical order in progress': [
        null,
        'un ordine identico già in corso',
      ],
      'a technical error': [null, 'un problema tecnico'],
      'an error in the recipient of the bonus': [
        null,
        'un errore nel destinatario del bonus',
      ],
      'an insufficient Miles balance': [null, 'un saldo miglia insufficiente'],
      'a deposit limit reached on your account': [
        null,
        'un limite di deposito raggiunto sul tuo conto',
      ],
      'You cannot offer this product to this player': [null, `L'articolo non può essere regalato a questo giocatore`],

      // ADDITIONAL TRANSLATIONS
      'Log in to order': [null, 'Accedi'],
      'Delete all filters': [null, 'Elimina tutti i filtri'],
      Materials: [null, 'Materiali'],
      'Next availability': [null, 'Prossima disponibilità'],
      'All categories': [null, 'Vedi tutto'],
      Filters: [null, 'Filtra'],
      'See all': [null, 'Vedi tutto'],
      'Check Details': [null, 'Vedi i dettagli'],
      'Place Order': [null, 'Ordinare'],
      'Enter a nickname': [null, 'Inserisci un nome utente'],
      'Your order will be shipped in multiple shipments': [
        null,
        'Il tuo ordine sarà spedito in più spedizioni',
      ],
      Offer: [null, 'Offerta'],
      View: [null, 'Vedi'],
      'Express order': [null, 'Ordine espresso'],
      Buy: [null, 'Acquista'],
      'Not enough miles. Please remove some items.': [
        null,
        'Miglia insufficienti. Si prega di rimuovere alcuni articoli.',
      ],
      'Not enough miles available for immediate order': [
        null,
        'Miglia insufficienti per un ordine immediato',
      ],
      'Place order': [null, 'Ordinare'],
      Confirm: [null, 'Confermare'],
      'Empty Cart': [null, 'Svuota il carrello'],
      'Please select colors and/or size': [
        null,
        'Si prega di selezionare colori e/o taglie',
      ],
      'Dematerialized product': [null, 'Prodotto dematerializzato'],
      Message: [null, 'Messaggio'],
      MILES: [null, 'MIGLIA'],
    },
  },
};
